import { render, staticRenderFns } from "./organizationDetial.vue?vue&type=template&id=9e45629e&scoped=true&"
import script from "./organizationDetial.vue?vue&type=script&lang=js&"
export * from "./organizationDetial.vue?vue&type=script&lang=js&"
import style0 from "./organizationDetial.vue?vue&type=style&index=0&id=9e45629e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e45629e",
  null
  
)

export default component.exports